const tag_de = {
  title: 'Tag',
  addNew: 'Tag erstellen',
  searchPlaceholder: 'Suche',
  groupView: 'Gruppenansicht',
  listView: 'Listenansicht',
  showEntries: 'Einträge anzeigen',
  noData: 'Keine Tags verfügbar',
  form: {
    createTitle: 'Tag erstellen',
    updateTitle: 'Tag bearbeiten',
    name: 'Name',
    namePlaceholder: 'Tag-Namen eingeben',
    nameRequired: 'Name ist erforderlich',
    color: 'Farbe',
    cancel: 'Abbrechen',
    create: 'Erstellen',
    save: 'Speichern'
  },
  table: {
    name: 'Name',
    color: 'Farbe',
    lastChange: 'Letzte Änderung',
  },
  message: {
    created: 'Tag wurde erstellt',
    createError: 'Erstellen des Tags fehlgeschlagen',
    updated: 'Tag wurde aktualisiert',
    updateError: 'Aktualisieren des Tags fehlgeschlagen'
  },
  delete: {
    title: 'Tag löschen',
    body: 'Sind Sie sicher, dass Sie diesen Tag löschen möchten?',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    success: 'Tag wurde gelöscht',
    fail: 'Löschen des Tags fehlgeschlagen'
  }
}

export default tag_de
